export default 'https://tme.understood.org/assets/mirror.05b3d2f6.lottie'